import { DRAW_MODEL } from "@/constants/drawModel";
import { PAGE_TYPE } from "@/constants/pageType";
import { GraphicInfo } from "@tuliu/base-map";
import { LatLngTuple } from "@tuliu/leaflet";
import { UnwrapRef } from "@vue/composition-api";
import { defineStore, PiniaCustomStateProperties } from "pinia";

export type Store = {
  // 当前路由对应的实际的页面类型
  pageType?: PAGE_TYPE;
  // APP 传递过来的页面类型
  queryPageType?: PAGE_TYPE;
  // 页面显示模式，不同的模式有一些不同的逻辑
  drawModel: DRAW_MODEL;
  // 地图中心点
  mapCenter: LatLngTuple;

  // 地图初始渲染数据
  initGraphicInfoList: GraphicInfo[];
  // 地图上渲染的数据
  graphicInfoList: GraphicInfo[];
  // 绘制地图产生的历史数据，撤销用
  snapshotList: GraphicInfo[][];

  // 控制地图是否在加载中
  mapIsPending: boolean;

  // 是否认领(确权)的数据
  isClaim: boolean;
  // 是否可以开始绘制
  isStarted: boolean;
};

type S = UnwrapRef<Store> & UnwrapRef<PiniaCustomStateProperties<Store>>;
type Getter<T> = (store: S) => T;

export type Getters = {
  // 绘制是否有历史记录
  hasHistory: Getter<boolean>;
  // 绘制是否全部闭合
  isFinish: Getter<boolean>;
  // 绘制时的提示信息
  tipMessage: Getter<string>;
  // 闭合的图形统计个数
  closedCount: Getter<number>;
};

export const useDrawStore = defineStore<"draw", Store, Getters>("draw", {
  state: () => {
    return {
      drawModel: DRAW_MODEL.create,
      pageType: undefined,
      queryPageType: undefined,
      initGraphicInfoList: [],
      graphicInfoList: [],
      snapshotList: [],
      mapCenter: [39.909187, 116.397451],
      mapIsPending: false,
      isClaim: false,
      isStarted: false,
    };
  },
  getters: {
    hasHistory(state) {
      return state.snapshotList.length > 0;
    },
    isFinish(state) {
      return (
        state.graphicInfoList.length > 0 &&
        state.graphicInfoList.every((info) => info.isClosed)
      );
    },
    tipMessage(state) {
      return state.isClaim
        ? "以下是你的确权土地，点击圆点拖动可修改轮廓"
        : // 编辑提示
        state.drawModel === DRAW_MODEL.update
        ? "点击圆点拖动可修改轮廓"
        : // 重新绘制
        !state.isStarted
        ? "点击【开始绘制】开启绘制地块之路"
        : !state.snapshotList.length
        ? "沿着地块边缘进行打点，系统自动帮你圈"
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !(state as any).isFinish
        ? "继续标点让地块闭合，完成绘制"
        : "点击圆点拖动可修改轮廓，或继续绘制地块";
    },
    closedCount(state) {
      return state.graphicInfoList.reduce(
        (count, info) => (info.isClosed ? ++count : count),
        0
      );
    },
  },
});
